import ConfirmCode from '@efex-components/TwoFactorCode/ConfirmCode';
import { Dialog, DialogTitle, DialogContent } from '@efexteam/components';
import ConfirmPassword from '@efex-components/confirmPassword/ConfirmPassword';
import { selectProfileData } from '@pages/profile/store/selectors';
import TWO_FACTOR_STEPS from '@pages/security/constants';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useWhiteLabelService from '@/layout/login/hooks/useWhiteLabel.service';
import LogoController from '@/layout/login/components/LogoController/LogoController';
import Disable from './Disable';
import DisableSuccess from './DisableSucess';
import Scan from './Scan';
import Success from './Sucess';
import Welcome from './Welcome';

interface TwoFactorProps {
  open: boolean;
  onClose: () => void;
}

const TwoFactor = ({ open, onClose }: TwoFactorProps) => {
  const { t } = useTranslation();
  const { whiteLabelState } = useWhiteLabelService();

  const userProfile = useSelector(selectProfileData);

  const [step, setStep] = useState(TWO_FACTOR_STEPS.CONFIRM_PASSWORD);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('tfTitle') || ''}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle showCloseButton onClick={onClose}>
        <LogoController
          isWhiteLabel={!!whiteLabelState.organizationID}
          efexLogoProps={{ className: 'mb-2 max-w-[100px] mx-auto' }}
          whiteLabelLogo={whiteLabelState.organizationLogoURL}
        />
      </DialogTitle>

      <DialogContent>
        {step === TWO_FACTOR_STEPS.CONFIRM_PASSWORD ? (
          <ConfirmPassword
            onValidPassword={() => setStep(TWO_FACTOR_STEPS.WELCOME)}
          />
        ) : null}
        {!userProfile?.has2FA ? (
          <>
            {step === TWO_FACTOR_STEPS.WELCOME ? (
              <Welcome
                goBack={() => setStep(TWO_FACTOR_STEPS.CONFIRM_PASSWORD)}
                nextStep={() => setStep(TWO_FACTOR_STEPS.SCAN)}
              />
            ) : null}
            {step === TWO_FACTOR_STEPS.SCAN ? (
              <Scan
                goBack={() => setStep(TWO_FACTOR_STEPS.WELCOME)}
                nextStep={() => setStep(TWO_FACTOR_STEPS.CONFIRM)}
              />
            ) : null}
            {step === TWO_FACTOR_STEPS.CONFIRM ? (
              <ConfirmCode
                goBack={() => setStep(TWO_FACTOR_STEPS.SCAN)}
                isValidated={() => setStep(TWO_FACTOR_STEPS.SUCCESS)}
              />
            ) : null}
            {step === TWO_FACTOR_STEPS.SUCCESS ? (
              <Success nextStep={onClose} />
            ) : null}
          </>
        ) : null}
        {userProfile?.has2FA ? (
          <>
            {step === TWO_FACTOR_STEPS.WELCOME ? (
              <Disable
                goBack={() => setStep(TWO_FACTOR_STEPS.CONFIRM_PASSWORD)}
                nextStep={() => setStep(TWO_FACTOR_STEPS.SUCCESS)}
              />
            ) : null}
            {step === TWO_FACTOR_STEPS.SUCCESS ? <DisableSuccess /> : null}
          </>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default TwoFactor;
